import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  AccountHolder,
  updateTerminal,
  UpdateTerminalBody,
} from "../../../services/accountService";
import useCreateAccountHolderNotesMutation from "./useCreateAccountHolderNotesMutation";

export default function useUpdateTerminalMutation(accountHolderCode: string) {
  const { mutateAsync: createNote } = useCreateAccountHolderNotesMutation();
  const queryClient = useQueryClient();

  return useMutation<string, string, UpdateTerminalBody>(
    (body: UpdateTerminalBody) => updateTerminal(body),
    {
      async onSuccess(_, updatedTerminal) {
        const accountConfigData = queryClient.getQueryData<AccountHolder>([
          "accountConfig",
          accountHolderCode,
        ]);

        queryClient.invalidateQueries(["accountConfig", accountHolderCode]);

        if (!accountConfigData) return;
        const updatedTerminalPreviousValue = accountConfigData.stores
          .at(0)
          ?.terminals.find((x) => x.id === updatedTerminal.id);

        const noteChanges: string[] = [];

        if (
          updatedTerminalPreviousValue?.friendlyName !==
          updatedTerminal.friendlyName
        ) {
          noteChanges.push(
            `friendly name (${updatedTerminalPreviousValue?.friendlyName} to ${updatedTerminal.friendlyName})`
          );
        }

        if (updatedTerminalPreviousValue?.enabled !== updatedTerminal.enabled) {
          noteChanges.push(
            `enabled (${
              updatedTerminalPreviousValue?.enabled ? "yes" : "no"
            } to ${updatedTerminal.enabled ? "yes" : "no"})`
          );
        }

        await createNote({
          accountHolderCode,
          freeText: `Terminal ${
            updatedTerminal.terminalId
          } changed: ${noteChanges.join(", ")}`,
        });
      },
    }
  );
}
